<template>
<div class="chapter">
<div class="inner_page">
<div class="pgmonospaced">
<br class="calibre1"/>
</div>
<h1 class="calibre2" id="pgepubid00000">MISTRESS WILDING</h1>
<h2 class="sigilnotintoc sigil_not_in_toc" id="calibre_pb_0">By Rafael Sabatini</h2>
<p class="calibre3"><br class="calibre1"/>
<br class="calibre1"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001_split_000.vue?34e9a406